module.exports = __webpack_public_path__ + "static/media/highway_out@2x.24351fb6.png";